import {
  FormControl,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { ProfileBlack, ProfileBlue } from "@platformx/shared/static-assets";
import { capitalizeFirstLetter, isSubsequence } from "@platformx/utilities";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import useDamContent from "./DamContent.style";
import InlineListLoader from "./InlineListLoader";

const PAGE_SIZE = 15;

// Component to render an author filter list
export function AuthorMenu({ setAuthor, label, author, searchQuery }) {
  const classes = useDamContent(); // Applying custom styles
  // Auto-pagination: how many authors are currently rendered. Grows as the user
  // scrolls to the bottom of the list (no page numbers).
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const AUTHOR = searchQuery
    ? label?.author?.filter((obj) => isSubsequence(searchQuery, obj.label.toLowerCase()))
    : label?.author;

  const authorList = AUTHOR || [];
  const visibleAuthors = authorList.slice(0, visibleCount);
  const hasMore = visibleCount < authorList.length;

  // Reset to the first chunk whenever the search filter changes.
  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [searchQuery]);

  // Handler to update the selected author
  const handleSelect = (selectedAuthor) => {
    setAuthor(selectedAuthor);
  };

  return (
    <FormControl variant='outlined' className='selectRoot'>
      <List id='authorScrollableDiv' sx={{ maxHeight: "305px", overflowY: "auto" }}>
        <InfiniteScroll
          dataLength={visibleAuthors.length}
          next={() => setVisibleCount((count) => count + PAGE_SIZE)}
          hasMore={hasMore}
          loader={<InlineListLoader />}
          scrollableTarget='authorScrollableDiv'>
          {visibleAuthors.map((obj) => (
            <ListItemButton
              className={classes.listitembox}
              key={obj.label}
              onClick={() => handleSelect(obj.label)}
              selected={author === obj.label}>
              <ListItemIcon className={classes.authoricon}>
                <img
                  style={{
                    height: "22px",
                    width: "22px",
                  }}
                  src={author === obj.label ? ProfileBlue : ProfileBlack}
                  alt='profile'
                />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  variant='p3medium'
                  color={author === obj.label ? "activeColor" : "inherit"}>
                  {capitalizeFirstLetter(obj.label?.toLowerCase())}
                </Typography>
              </ListItemText>
            </ListItemButton>
          ))}
        </InfiniteScroll>
      </List>
    </FormControl>
  );
}
